import React from 'react';

const Minus = () => {
  return (
    <svg width="18" height="2" viewBox="0 0 18 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" y1="1" x2="17" y2="1" stroke="#DB684D" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
};

export default Minus;
